module.exports = __webpack_public_path__ + "img/spiral.3a4e6325.jpg";